<template>
  <v-container v-if="show" fluid>
    <v-card
        v-if="disabledByStatus"
        class="drop-zone"
        @click="triggerFileInput"
        @drop.prevent="onDrop"
        @dragover.prevent>
      <v-file-input
          ref="fileInput"
          v-model="file"
          accept=".pdf,.doc,.docx,.txt"
          full-width
          hide-input
          label="Selecione um arquivo"
          prepend-icon=""
          @change="onFileChange"
      />
      <div class="drop-zone-text">
        <div class="text-icon-zone">
          <div>
            Arraste e solte seu arquivo aqui ou clique para selecionar
          </div>

          <div>
            <v-icon color="blue" large>
              mdi-cloud-upload-outline
            </v-icon>
          </div>
        </div>

      </div>
    </v-card>
    <v-data-table
        :headers="headers"
        :items="documentsDataClickSign"
        class="has-documents"
        no-data-text="Sem documentos para exibir!">

      <template v-slot:item.attributes.filename="{ item }">
        {{ wrapFilename(item.attributes.filename) }}
      </template>

      <template v-slot:item.attributes.status="{ item }">
        {{ statusMapper[item.attributes.status] }}
      </template>

      <template v-slot:item.actions="{ item }">
        <div class="td-action">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  v-bind="attrs"
                  v-on="on">
                <v-icon color="blue" small>
                  mdi-download
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                  v-for="(option, index) in getFileOptions(item)"
                  :key="index"
                  v-if="option.visible"
                  @click="handleFileOption(option, item)">
                <v-list-item-title>{{ option.label }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-btn v-if="getStatusEnvelope !== 'draft' && item.attributes.status === 'running'" @click="confirmCancelDocument(item)">
            <v-icon small>
              mdi-cancel
            </v-icon>
          </v-btn>

          <v-btn @click="confirmDelete(item)" v-if="getStatusEnvelope === 'draft'">
            <v-icon color="error" small>
              mdi-delete
            </v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>

    <v-dialog v-model="isLoadingDocument" max-width="420" persistent>
      <v-list class="py-5" color="primary" elevation="12" rounded style="max-height: 400px; overflow-y: auto;">
        <v-list-item class="d-flex justify-space-between">
          <div>
            <span style="color: white; font-size: large;">Salvando Documentos...</span>
          </div>
          <div>
            <v-progress-circular color="#1A237E" indeterminate size="32" width="2"></v-progress-circular>
          </div>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item v-for="(doc, index) in savedDocs" :key="index">
          <v-list-item-content>
            <v-list-item-title style="color: white;">
              {{ doc.name }} - 100%
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-dialog>

  </v-container>
</template>

<script>
import DocumentsScript from "./DocumentsScript.js";

export default DocumentsScript;
</script>

<style scoped>
.drop-zone {
  border: 2px dashed #1976D2;
  border-radius: 8px;
  padding: 40px;
  text-align: center;
  position: relative;
  cursor: pointer;
}

.drop-zone-text {
  user-select: none;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #1976D2;
  font-size: 16px;
}

.text-icon-zone {
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.has-documents {
  margin-top: 20px;
  height: 600px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.td-action {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
}

</style>